import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { AxiosCanceler } from "./helper/axiosCancel";
import { ResultEnum } from "../enums/httpEnum";
import { message } from "antd";
import { ResultData } from "./interface";
import { checkStatus } from "./helper/checkStatus";
import NProgress from "./myprogress";
import { tryHideFullScreenLoading } from "../config/serviceLoading";
const axiosCanceler = new AxiosCanceler();
/**
 * release服务地址
 * * */
export const BaseImageUrl = "https://hubyjs.org.cn/home/";
export const ShareUrl = "https://hubyjs.org.cn/home/";

/**
 * 远程服务地址
 * */
// export const BaseImageUrl = "http://121.40.129.41:80/";
// export const ShareUrl = "http://121.40.129.41/";


const config = {
    // 默认地址请求地址，可在 .env 开头文件中修改
    // baseURL: "http://172.16.12.71/herbarium",
    baseURL: "https://hubyjs.org.cn/home/herbarium",
    // 设置超时时间（10s）、、
    timeout: 100000,
    // 跨域时候允许携带凭证
    withCredentials: true,
    headers: {
    //     c、rossDomain: "true",
    //     Accept: "*/*",
        'Access-Control-Allow-Origin': '*',
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, Authorization, X-Auth-Token",
    //     referer: "",、
    }
};

class RequestHttp {
    service: AxiosInstance;
    public constructor(config: any) {
        // 实例化axios
        this.service = axios.create(config);

        /**
         * @description 请求拦截器
         * 客户端发送请求 -> [请求拦截器] -> 服务器
         * token校验(JWT) : 接受服务器返回的token,存储到redux/本地储存当中
         */
        this.service.interceptors.request.use(
            (config: any) => {
                // * 将当前请求添加到 pending 中
                NProgress.start();
                axiosCanceler.addPending(config);
                
                const token = localStorage.getItem('token');
                config.headers!.Authorization = token; //非空断言!
                // * 如果当前请求不需要显示 loading,在api服务中通过指定的第三个参数: { headers: { noLoading: true } }来控制不显示loading，参见loginApi
                // return { ...config, headers: { ...config.headers, "x-access-token": "" }};
                return { ...config, headers: { ...config.headers }};
            },
            (error: AxiosError) => {
                return Promise.reject(error);
            }
        );

        /**
         * @description 响应拦截器
         *  服务器换返回信息 -> [拦截统一处理] -> 客户端JS获取到信息
         */
        this.service.interceptors.response.use(
            (response: AxiosResponse) => {
                const { data, config } = response;
                NProgress.done();
                if (data?.data?.token) {
                    localStorage.setItem("token", data.data.token);
                }
                // * 在请求结束后，移除本次请求(关闭loading)
                axiosCanceler.removePending(config);
                tryHideFullScreenLoading();
                // * 登录失效（code == 401）
                if (data.code === ResultEnum.OVERDUE) {
                    // store.dispatch(setToken(""));
                    // message.error(data.msg);
                    localStorage.removeItem('token');
                    window.location.href = "/login";
                    return Promise.reject(data);
                }
                // * 全局错误信息拦截（防止下载文件得时候返回数据流，没有code，直接报错）
                if (data.code && data.code !== ResultEnum.SUCCESS) {
                    message.error(data.message);
                    return Promise.reject(data);
                }
                // * 成功请求（在页面上除非特殊情况，否则不用处理失败逻辑）
                return data;
            },
            async (error: AxiosError) => {
                const { response } = error;
                NProgress.done();
                tryHideFullScreenLoading();
                // 请求超时单独判断，请求超时没有 response
                if (error.message.indexOf("timeout") !== -1) message.error("请求超时，请稍后再试");
                // 根据响应的错误状态码，做不同的处理
                if (response) checkStatus(response.status);
                // 服务器结果都没有返回(可能服务器错误可能客户端断网) 断网处理:可以跳转到断网页面
                if (!window.navigator.onLine) window.location.hash = "/500";
                return Promise.reject(error);
            }
        );
    }

    // * 常用请求方法封装
    get<T>(url: string, params?: object, _object = {}): Promise<ResultData<T>> {
        return this.service.get(url, { params, ..._object });
    }
    post<T>(url: string, params?: object, _object = {}): Promise<ResultData<T>> {
        return this.service.post(url, params, _object);
    }
    put<T>(url: string, params?: object, _object = {}): Promise<ResultData<T>> {
        return this.service.put(url, params, _object);
    }
    delete<T>(url: string, params?: any, _object = {}): Promise<ResultData<T>> {
        return this.service.delete(url, { params, ..._object });
    }
}

export default new RequestHttp(config);